module.exports = __webpack_public_path__ + "img/popup_button6_normal.bcb4037d.png";